import {  createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiServices from "../../services/apiServices";

 

const initialState = {
  type:'success',
  msg :"",
  show:false
};

let alertBoxSlice = createSlice({
  name: "alertBox_state",
  initialState,
  reducers: {
    // insert actions here

    //action 2
    showSuccess: function (state, action) {
      // api call for the fetch all alertBox from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.type = "success"
      state.msg=payload
      state.show = true

      
    },
    showError: function (state, action) {
      // api call for the fetch all alertBox from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.type = "error"
      state.msg=payload
      state.show = true
      
    },
    showInfo: function (state, action) {
      // api call for the fetch all alertBox from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.type = "info"
      state.msg=payload
      state.show = true

      
    },
   
    closeAlertBox: function (state, action) {
      // api call for the fetch all alertBox from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      
      state.msg=""
      state.show = false

      
    }
  },
   
});
export const {
  showSuccess,
  closeAlertBox
} = alertBoxSlice.actions;
 
export default alertBoxSlice.reducer;
